import { ComponentProps } from 'react';
import { LinkProps, Link as RouterLink } from 'react-router';
import { tv, VariantProps } from 'tailwind-variants';

const styles = tv({
  base: 'underline hover:no-underline',
  variants: {
    color: {
      primary: 'text-primary-teal',
      secondary: 'text-rw-neutral-dark-gray',
      white: 'text-white',
    },
    underline: {
      initial: 'underline hover:no-underline',
      hover: 'no-underline hover:underline',
      none: 'no-underline',
    },
  },
  defaultVariants: {
    color: 'primary',
    underline: 'initial',
  },
});

export const Link = ({
  className,
  children,
  color,
  underline,
  ...props
}: LinkProps & VariantProps<typeof styles>) => {
  return (
    <RouterLink
      {...props}
      className={styles({ color, underline, class: className })}
    >
      {children}
    </RouterLink>
  );
};

export const ExternalLink = (props: ComponentProps<typeof Link>) => (
  <Link {...props} target="_blank" rel="noopener noreferrer" />
);
